import { handleLogedOut } from './handler';
export { sendPacket, generateInvoice, triggerEvent };

function sendPacket() {
	var packet = $("input[type='radio'][name='kaardipakett']:checked").val();
	console.log(packet);
	$.getJSON(WWW_INDEX + "?f=" + MODULE_NAME, {
		packet: packet
	});
}

function generateInvoice(event, invoice) {
	event.preventDefault();
	$.ajax({
		url: invoice
	});
	var invoiceButton = document.querySelector('a[data-bank="invoice"]');
	invoiceButton.classList.add("locked");
	document.querySelector('.bank-links').classList.add("locked");
	var generatedNote = document.createElement("section");
	generatedNote.classList.add("success");
	generatedNote.classList.add("grin-x");
	generatedNote.classList.add("large-12");
	generatedNote.innerHTML = "Arve on saadetud teie e-postile. <br/>Arve on leitav ka <a href='/index.php?f=arved'>Minu arved</a> moodulist.";
	document.querySelector('.invoice').appendChild(generatedNote);
	return false;
}

function triggerEvent(el, type) {
	if (type === "click") {
		try {
			var event = new MouseEvent("click", {
				view: window,
				bubbles: true,
				cancelable: true
			});
			return el.dispatchEvent(event);
		} catch (e) {

		}
	}

	if ("createEvent" in document) {
		// modern browsers, IE9+
		var e = document.createEvent("HTMLEvents");
		e.initEvent(type, false, true);
		return el.dispatchEvent(e);
	} else {
		// IE 8
		var e = document.createEventObject();
		e.eventType = type;
		return el.fireEvent("on" + e.eventType, e);
	}
}

$(document).on("click", ".proovi-tasuta-link", function (e) {
	var currentEventTarget = e.currentTarget;
	console.log(currentEventTarget);
	prooviTasutaModal(currentEventTarget);
	return false;
});

function prooviTasutaModal(currentEventTarget) {
	var link = currentEventTarget.dataset.link;

	if (USER_ID > 0) {
		$("#prooviTasutaModal").show();
		document.querySelector(".alusta").setAttribute('href', link);
	} else {
		$(".cta-login").show();

		if (currentEventTarget.dataset.link === "/?f=kaardirakendus&try-free=bronze") {
			sessionStorage.setItem('service', 'bronze-tasuta');
		} else if (currentEventTarget.dataset.link === "/?f=kaardirakendus&try-free=silver") {
			sessionStorage.setItem('service', 'silver-tasuta');
		} else if (currentEventTarget.dataset.link === "/?f=kaardirakendus&try-free=gold") {
			sessionStorage.setItem('service', 'gold-tasuta');
		}

		handleLogedOut();
	}
}